import React from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import { AnnouncementBanner } from '@/components/ui/announcement-banner';
import PromoBanner from '@/components/ui/promo-banner';

export default function SplashLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="layout-body overflow-x-hidden">
      <PromoBanner />
      <SiteHeader />
      <main className="overflow-x-hidden">{children}</main>
      <SiteFooter />
    </div>
  );
}
